import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { getHelpVideoMap } from "../../Common/HelpVideoMap";
import "./Modal.css";
import "./AlertModal.css";

const AlertModal = ({ show, onHide: onHideProp, AlertModalTitle: titleProp, AlertModalMessage: messageProp, AlertModalButtons: buttonsProp, videoKey, attributes }) => {
  let AlertModalTitle = titleProp;
  let AlertModalMessage = messageProp;
  let onHide = onHideProp;
  let AlertModalButtons = buttonsProp;

  if (typeof attributes !== "undefined") {
    AlertModalTitle = attributes.AlertModalTitle;
    AlertModalMessage = attributes.AlertModalMessage;
    onHide = attributes.onHide;
    AlertModalButtons = attributes.AlertModalButtons;
    videoKey = attributes.videoKey;
  }

  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    if (!show || !videoKey) {
      setVideoUrl(null);
      return;
    }
    getHelpVideoMap().then((map) => setVideoUrl(map[videoKey] || null));
  }, [show, videoKey]);

  const handleButtonClick = (button) => {
    if (button.Method != null) button.Method(button.Title);
    onHide();
  };

  const isSingle = AlertModalButtons.length === 1;

  return (
    <div className="modal">
      <Modal
        show={show}
        animation={false}
        dialogClassName="am-dialog"
        aria-labelledby="am-title"
        centered
        onHide={onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="am-shell">

            {/* ── Header ── */}
            <div className="am-header">
              <div className="am-header-icon">
                <FontAwesomeIcon icon={solid("circle-info")} />
              </div>
              <h2 className="am-title" id="am-title">{AlertModalTitle}</h2>
              <button className="am-close" onClick={onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            {/* ── Body ── */}
            {AlertModalMessage ? (
              <div className="am-body">
                <p className="am-message">{AlertModalMessage}</p>
                {videoUrl ? (
                  <button
                    className="am-watch-how"
                    onClick={() => window.open(videoUrl, "_blank", "noopener,noreferrer")}
                  >
                    <FontAwesomeIcon icon={solid("circle-play")} />
                    Watch how
                  </button>
                ) : null}
              </div>
            ) : null}

            {/* ── Footer ── */}
            <div className={`am-footer${isSingle ? " am-single" : ""}`}>
              {AlertModalButtons.map((button, i) => {
                const isAction = button.Method != null;
                const isLast = i === AlertModalButtons.length - 1;
                let cls = "am-btn ";
                if (isSingle) {
                  cls += "am-btn-action";
                } else if (!isAction || isLast) {
                  cls += "am-btn-cancel";
                } else {
                  cls += "am-btn-action";
                }
                return (
                  <button
                    key={`btn-${i}`}
                    className={cls}
                    onClick={() => handleButtonClick(button)}
                  >
                    {button.Title}
                  </button>
                );
              })}
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AlertModal;
